import React, { useRef, useEffect, useState } from "react";
import {
  View,
  StyleSheet,
  ScrollView,
  Image,
  Modal,
  TouchableOpacity,
} from "react-native";

import { ADMIN_TOKENS } from "../../../../styles/adminTokens";
import { TGetMessagesResponse } from "../../../../services/api-clinic";
import { MessageBubble } from "./shared";
import MessageThreadImageModalContent from "./MessageThreadImageModalContent";

type MessageThreadTextsProps = {
  messages: TGetMessagesResponse["messages"];
};

const MessageThreadTexts: React.FC<MessageThreadTextsProps> = ({
  messages,
}) => {
  const scrollViewRef = useRef<ScrollView>(null);
  const prevMessagesLength = useRef<number>(0);

  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(
    null,
  );
  const [selectedMessageIndex, setSelectedMessageIndex] = useState<
    string[] | null
  >(null);

  useEffect(() => {
    if (messages.length > prevMessagesLength.current) {
      scrollViewRef.current?.scrollToEnd({ animated: true });
    }
    prevMessagesLength.current = messages.length;
  }, [messages]);

  return (
    <View style={styles.container}>
      <ScrollView
        ref={scrollViewRef}
        horizontal={false}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.bubbleList}>
          {messages
            .slice()
            .reverse()
            .map((message, index) => {
              const isOutbound = message.sender_type === "CLINIC";

              return (
                <MessageBubble
                  key={`${message.created_at || "msg"}-${index}`}
                  body={message.message}
                  isOutbound={isOutbound}
                  attachmentsNode={
                    message.thumbnail_urls.length > 0 ? (
                      <ScrollView
                        horizontal
                        showsHorizontalScrollIndicator={false}
                      >
                        <View style={styles.imagesContainer}>
                          {message.thumbnail_urls.map((url, idx) => (
                            <TouchableOpacity
                              key={`${url}-${idx}`}
                              onPress={() => {
                                setSelectedImageIndex(idx);
                                setSelectedMessageIndex(message.image_urls);
                              }}
                            >
                              <Image
                                source={{ uri: url }}
                                style={styles.image}
                              />
                            </TouchableOpacity>
                          ))}
                        </View>
                      </ScrollView>
                    ) : null
                  }
                />
              );
            })}
        </View>
      </ScrollView>

      <Modal
        visible={selectedImageIndex !== null}
        transparent
        animationType="fade"
      >
        {selectedImageIndex !== null && selectedMessageIndex !== null ? (
          <MessageThreadImageModalContent
            image_initial_index={selectedImageIndex}
            image_urls={selectedMessageIndex}
            handleModalClose={() => {
              setSelectedImageIndex(null);
              setSelectedMessageIndex(null);
            }}
          />
        ) : null}
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  bubbleList: {
    gap: ADMIN_TOKENS.spacing.xs,
  },
  imagesContainer: {
    flexDirection: "row",
    marginTop: ADMIN_TOKENS.spacing.xs,
  },
  image: {
    width: 100,
    height: 100,
    marginRight: ADMIN_TOKENS.spacing.xs,
    borderRadius: ADMIN_TOKENS.radius.md,
    resizeMode: "contain",
  },
});

export default MessageThreadTexts;
